import React, { useState, useContext } from 'react';
import AditivoRenegociacao from '../../AditivoRenegociacao';

import { AditivoSection } from './styles';
import { ButtonPrimary } from '../../../StyledComponent';
import CountdownTimer from '../../../CountDown';
import { ContextRenegociacao } from '../../../../services/renegociacao';
import MessagePopUp from '../../../MessagePopup';

const DocToSign = ({
  tema,
  contratoSelecionado,
  getParcelas,
  dadosDocSign,
}) => {
  const { postReenviarDocuSign } = useContext(ContextRenegociacao);
  const [showDocToSign, setShowDocToSign] = useState(false);
  const [emailEnviado, setEmailEnviado] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleShowDocToSign = () => {
    setShowDocToSign((prevState) => !prevState);
  };

  async function handleEnvioEmailAditivoContratual() {
    setIsLoading(true);
    setIsError(false);
    const { idVenda, idVendaCarteira } = contratoSelecionado;

    try {
      await postReenviarDocuSign({ idVenda, idVendaCarteira });
      setEmailEnviado(true);
    } catch (e) {
      console.error(e);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }

  function handleTextTimer() {
    if (isLoading) {
      return 'Reenviando...';
    }

    return 'Reenviar';
  }

  async function handleCloseAditivoEnviado() {
    setEmailEnviado(false);
    await getParcelas();
  }

  return (
    <>
      <AditivoSection color={tema.primaryColor}>
        <h4>Vimos que você tem uma renegociação em aberto</h4>
        <p>
          Para prosseguir, clique no botão abaixo para{' '}
          <b>assinar digitalmente o aditivo contratual</b> e gerar o boleto para
          pagamento. Lembrando que suas condições são válidas somente até a data
          de vencimento da parcela de entrada.
        </p>

        <ButtonPrimary onClick={handleShowDocToSign} tema={tema} width={'396'}>
          VISUALIZAR E ASSINAR O ADITIVO
        </ButtonPrimary>

        <p>
          Se preferir, você pode assinar pelo link enviado ao seu e-mail de
          cadastro.{' '}
          <CountdownTimer
            tema={tema}
            text={handleTextTimer()}
            minutes={dadosDocSign?.minutosReenvio}
            onClickWhenCountDownFinish={handleEnvioEmailAditivoContratual}
          />
        </p>
        <p>
          Caso já tenha realizado a assinatura, aguarde alguns minutos e
          atualize esta página para liberação das parcelas.
        </p>
      </AditivoSection>

      <AditivoRenegociacao
        showDocToSign={showDocToSign}
        handleShowDocToSign={handleShowDocToSign}
        tema={tema}
        dadosDocSign={dadosDocSign}
        getParcelas={getParcelas}
      />
      {isError && (
        <MessagePopUp
          theme={tema}
          isError
          title={'Erro'}
          message={'Erro ao reenviar o email! Por favor tente novamente!'}
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            onClick={() => setIsError(false)}
          >
            Fechar
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {emailEnviado && (
        <MessagePopUp
          theme={tema}
          txtAlign={'center'}
          title={'Aditivo reenviado com sucesso'}
          message={
            <span style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <span>Não se esqueça de verificar também a caixa de SPAM.</span>
              <span>
                Se for necessário alterar o e-mail, entre em contato com a nossa
                Central de Relacionamento em <b>4002-2600.</b>
              </span>
            </span>
          }
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            onClick={handleCloseAditivoEnviado}
          >
            Fechar
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </>
  );
};

export default DocToSign;
